import { useState } from "react";

export default function useFocus(): [boolean, { onFocus: () => void; onBlur: () => void }] {
    const [focused, setFocused] = useState(false);

    const props = {
        onFocus: () => setFocused(true),
        onBlur: () => setFocused(false),
    };

    return [focused, props];
}
